<template>
  <div>
    <div class="bg-white dark-bg-custom rounded-lg">
      <ActitiveTabcomponent
        :tabs="mainTabs"
        :defaultTab="'lead'"
        @tab-changed="onTabChanged"
        ref="tabComponent"
      >
        <template #tab-buttons>
          <v-icon @click="cancelForm">mdi-close</v-icon>
        </template>
        <template #lead>
          <div class="form-content">
            <v-form ref="form" @submit.prevent="addLead">
              <!-- Lead Information Section -->
              <div class="form-section form-content-border">
                <h4 class="section-title">
                  <v-icon color="primary" class="mr-2">mdi-information-outline</v-icon>
                  Information
                </h4>
                <div class="section-content">
                  <v-row>
                    <v-col cols="12" :md="isDefaultEnabled ? 6 : 12" class="py-0">
                      <v-text-field
                        v-model="leadName"
                        dense
                        required
                        color="red"
                        :label="leadLable.leadFormObj.lead + ' *'"
                        outlined
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="6" v-if="isDefaultEnabled" class="py-0">
                      <v-text-field
                        v-model="sourceOfLead"
                        label="Source of lead"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="12" v-if="isDefaultEnabled" class="py-0">
                      <v-combobox
                        v-model="leadTags"
                        :items="tags"
                        hide-selected
                        hint="Press Enter to add new tag"
                        label="Add Lead Tags"
                        persistent-hint
                        multiple
                        small-chips
                        outlined
                        dense
                      >
                        <template v-slot:selection="{ item }">
                          <v-chip @click="removeChip(item, leadTags)">
                            {{ item }}
                            <v-icon small class="ml-2">mdi-close-circle</v-icon>
                          </v-chip>
                        </template>
                      </v-combobox>
                    </v-col>

                    <v-col cols="12" md="12" v-if="!isComplaintsEnabled" class="py-0">
                      <v-textarea
                        @input="validateLeadDescription"
                        auto-grow
                        :label="leadLable.leadFormObj.description"
                        v-model="leadDescription"
                        outlined
                        dense
                        rows="3"
                      ></v-textarea>
                      <div class="flex justify-end">
                        <p class="text-sm text-gray-500 mb-0">
                          {{ remainingChar }} character remaining
                        </p>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </div>

              <!-- Product Details Section -->
              <div class="form-section form-content-border" v-if="isComplaintsEnabled">
                <h4 class="section-title">
                  <v-icon color="primary" class="mr-2">mdi-package-variant-closed</v-icon>
                  Product Details
                </h4>
                <div class="section-content">
                  <v-row>
                    <v-col cols="12" md="6" class="py-0">
                      <v-autocomplete
                        v-model="productName"
                        :items="products"
                        item-text="productName"
                        item-value="_id"
                        dense
                        label="Product Name"
                        placeholder="Start typing to Search"
                        :loading="productLoading"
                        @update:search-input="debounceProduct"
                        :search-input.sync="searchProduct"
                        cache-items
                        hide-no-data
                        outlined
                      ></v-autocomplete>
                    </v-col>

                    <v-col cols="12" md="6" v-if="leadLable.leadFormObj.productMaker" class="py-0">
                      <v-select
                        v-model="productMaker"
                        dense
                        :items="filteredProductMakers"
                        item-text="maker.partnerName"
                        item-value="maker._id"
                        :label="leadLable.leadFormObj.productMaker"
                        outlined
                      ></v-select>
                    </v-col>

                    <v-col cols="12" md="6" v-if="leadLable.leadFormObj.modelNumber" class="py-0">
                      <v-text-field
                        v-model="modelNumber"
                        dense
                        :label="leadLable.leadFormObj.modelNumber"
                        outlined
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="6" class="py-0">
                      <v-text-field
                        v-model="productBillNumber"
                        dense
                        label="Bill Number"
                        outlined
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="6" class="py-0">
                      <v-text-field
                        type="number"
                        v-model="productPrice"
                        label="Product Price"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="6" class="py-0">
                      <v-text-field
                        type="date"
                        v-model="productMakeDate"
                        label="Product Make Date"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="6" class="py-0">
                      <v-text-field
                        type="date"
                        v-model="productSoldOn"
                        label="Product Sale Date"
                        @input="calculateWarrantyEndDate"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="6" class="py-0">
                      <v-select
                        :items="warrantyPeriods"
                        item-text="text"
                        item-value="value"
                        v-model="defaultWarrantyPeriod"
                        label="Warranty Period"
                        @input="calculateWarrantyEndDate"
                        outlined
                        dense
                      ></v-select>
                    </v-col>

                    <v-col cols="12" md="6" v-if="!!productSoldOn" class="py-0">
                      <v-text-field
                        type="date"
                        v-model="productWarrantyEndDate"
                        label="Warranty End Date"
                        disabled
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="6" v-if="!!productSoldOn" class="py-0">
                      <v-select
                        v-model="warrantyStatus"
                        label="Warranty Status:"
                        :items="warrantyOptions"
                        item-text="warranty"
                        item-value="warranty"
                        disabled
                        outlined
                        dense
                      ></v-select>
                    </v-col>

                    <v-col cols="12" md="6" class="py-0">
                      <v-select
                        v-model="haveExtendedWarranty"
                        label="Extended Warranty"
                        :items="[
                          { text: 'Yes', value: true },
                          { text: 'No', value: false }
                        ]"
                        item-value="value"
                        item-text="text"
                        outlined
                        dense
                      ></v-select>
                    </v-col>

                    <v-col cols="12" md="6" v-if="haveExtendedWarranty" class="py-0">
                      <v-text-field
                        type="number"
                        label="Extended Warranty Period"
                        v-model="extendedWarrantyPeriod"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="6" class="py-0">
                      <v-select
                        v-model="haveAmcPlan"
                        label="AMC Plan Active"
                        :items="[
                          { text: 'AMC Active', value: true },
                          { text: 'AMC Inactive', value: false },
                          { text: 'N/A', value: null }
                        ]"
                        outlined
                        dense
                      ></v-select>
                    </v-col>

                    <v-col cols="12" md="6" v-if="haveAmcPlan !== null" class="py-0">
                      <v-text-field
                        type="date"
                        v-model="productAmcEndDate"
                        label="AMC End Date"
                        required
                        :rules="rules.amcEndDate"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </div>
              </div>

              <!-- Company Details Section -->
              <div class="form-section form-content-border">
                <h4 class="section-title">
                  <v-icon color="primary" class="mr-2">mdi-domain</v-icon>
                  Company Details
                </h4>
                <div class="section-content">
                  <v-row>
                    <v-col cols="12" md="6" class="py-0">
                      <v-autocomplete
                        v-model="selectedCompanyId"
                        :label="leadLable.leadFormObj.companyName"
                        :search-input.sync="searchCompany"
                        :items="companies"
                        item-text="name"
                        item-value="_id"
                        append-icon="mdi-plus"
                        @click:append="showAddCompany = true"
                        @update:search-input="handleCompany"
                        outlined
                        dense
                      ></v-autocomplete>
                    </v-col>

                    <v-col cols="12" md="6" class="py-0">
                      <v-autocomplete
                        :label="leadLable.leadFormObj.companyBranch"
                        v-model="selectedBranchId"
                        :items="selectedCompanyBranches"
                        :disabled="!selectedCompanyId"
                        item-value="_id"
                        :search-input.sync="searchBranch"
                        :item-text="
                          (item) =>
                            `${item.alias ? '[ ALIAS - ' + item.alias + ' ] - ' : ''}${
                              item?.address?.addressLine1 || ''
                            } ${item?.address?.addressLine2 || ''} ${item?.address?.city || ''}, ${
                              item?.address?.state || ''
                            }, ${item?.address?.country || ''}, ${item?.address?.pinCode || ''}`
                        "
                        :append-icon="selectedCompanyId ? 'mdi-plus' : ''"
                        @click:append="showAddBranch = true"
                        @update:search-input="handleBranchSearch"
                        outlined
                        dense
                      >
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                </div>
              </div>

              <!-- Contact Details Section -->
              <div class="form-section form-content-border" v-if="selectedBranchId !== null">
                <div class="d-flex justify-space-between align-center mb-4">
                  <h4 class="section-title mb-0">
                    <v-icon color="primary" class="mr-2">mdi-account-box-multiple</v-icon>
                    Contact Details
                  </h4>
                  <a
                    v-if="selectedCompanyId !== '' && selectedBranchId !== null"
                    class="text-decoration-underline primary--text font-weight-medium cursor-pointer"
                    @click="openAddContactDialog"
                  >
                    + Add Contact
                  </a>
                </div>

                <div class="section-content">
                  <v-expansion-panels v-if="editableContacts.length > 0" accordion multiple>
                    <v-expansion-panel
                      v-for="(contact, index) in editableContacts"
                      :key="contact._id"
                    >
                      <v-expansion-panel-header class="py-2">
                        <div class="d-flex align-center">
                          <span class="font-weight-medium mr-4">{{
                            contact.fullName || 'Contact ' + (index + 1)
                          }}</span>
                          <v-chip x-small v-if="selectedContactId === contact._id" color="primary"
                            >Primary</v-chip
                          >
                        </div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row class="mt-2">
                          <v-col cols="12" md="4" class="py-0">
                            <v-text-field
                              v-model="contact.fullName"
                              dense
                              :label="contactLabels.contactLabels"
                              outlined
                            ></v-text-field>
                          </v-col>

                          <v-col cols="12" md="4" class="py-0">
                            <v-text-field
                              v-model="contact.designation"
                              dense
                              :label="contactLabels.contactDesignation"
                              outlined
                            ></v-text-field>
                          </v-col>

                          <v-col cols="12" md="4" class="py-0">
                            <v-text-field
                              v-model="contact.phoneNumber"
                              dense
                              :label="contactLabels.contactNumber"
                              outlined
                            ></v-text-field>
                          </v-col>

                          <v-col cols="12" md="4" class="py-0">
                            <v-text-field
                              v-model="contact.email"
                              dense
                              :label="contactLabels.contactEmail"
                              outlined
                            ></v-text-field>
                          </v-col>

                          <v-col cols="12" md="4" class="py-0">
                            <v-text-field
                              v-model="contact.decisionMaker"
                              dense
                              :label="contactLabels.decision"
                              outlined
                            ></v-text-field>
                          </v-col>

                          <v-col cols="12" md="4" class="d-flex align-center py-0">
                            <v-checkbox
                              :input-value="selectedContactId === contact._id"
                              @change="updateSelectedContact(contact._id)"
                              label="Select as primary"
                              hide-details
                              dense
                              class="mt-0"
                            ></v-checkbox>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>

                  <div v-else class="text-center py-4 grey--text">
                    No contacts found. Add a contact using the button above.
                  </div>
                </div>
              </div>
            </v-form>
          </div>
        </template>
        <template #bulk>
          <GenericBulkUpload
            :title="'Add Lead'"
            :entityName="'Lead'"
            :requiredColumns="requiredColumns"
            :uploadEndpoint="uploadEndpoint"
            @save-button-visibility="handleSaveButtonVisibility"
            :successKey="'success'"
            :failedKey="'failed'"
            :invalidItemsKey="'invalidItems'"
            :method="'post'"
            :enableSave="false"
            :controlParentSaveButton="true"
            :sampleData="sampleData"
            :additionalPayload="additionalPayload"
          />
        </template>
      </ActitiveTabcomponent>

      <div class="flex justify-end p-4 border-t border-gray-200">
        <v-btn @click="cancelForm" text class="normal-case"> Cancel </v-btn>
        <v-btn
          v-if="showSaveButton"
          type="submit"
          :color="$vuetify.theme.currentTheme.primary"
          class="normal-case white--text"
          @click="addLead"
        >
          <v-icon left>mdi-content-save</v-icon>
          Save
        </v-btn>
      </div>
    </div>
    <v-dialog v-model="showAddCompany" width="auto">
      <CompanyAddress
        :isOpen="showAddCompany"
        @cancel="showAddCompany = false"
        @save="addCompany"
        title="Add Company"
        :companies="companies"
      />
    </v-dialog>
    <v-dialog v-model="showAddBranch" width="auto">
      <CompanyAddress
        :company="selectedCompanyName"
        @cancel="showAddBranch = false"
        :isOpen="showAddBranch"
        @save="addBranch"
        title="Add Branch"
      />
    </v-dialog>
    <v-dialog v-model="showContactDialog" max-width="600">
      <AddContact
        :selectedBranchId="selectedBranchId"
        @close="showContactDialog = false"
        @contact-added="handleContactAdded"
      />
    </v-dialog>
  </div>
</template>

<script>
import CompanyAddress from '@/components/Workforce/CompanyAddress.vue'
import AddContact from '../CompanyManagement/AddContactForm.vue'
import {
  leadCreationSuccess,
  leadCreationError,
  companyCreationSuccess,
  companyCreationError,
  descriptionLimit
} from '@/utils/toastMessages'
import { sortDropdownOptions } from '@/utils/common'
import { leadLabels, contactLabels } from '@/utils/workforce/formLabels'
import ActitiveTabcomponent from '@/components/ActitiveTabcomponent.vue'
import { debounce } from '@/utils/common'
import GenericBulkUpload from '../CollectionManagement/GenericBulkUpload.vue'
import { axiosUrl } from '@/utils/workforceApi'

export default {
  layout: 'Workforce/default',
  name: 'AddLeadDuplicate',
  components: {
    AddContact,
    ActitiveTabcomponent,
    GenericBulkUpload,
    CompanyAddress
  },
  data() {
    return {
      userData: this.$store.state.wfmPermissions,
      orgCode: this.$storage.getUniversal('organization_code'),
      leadLabels: leadLabels,
      contactLabels: contactLabels,
      isLoading: true,
      productLoading: false,
      showModal: false,
      leads: [],
      contacts: [],
      products: [],
      leadTags: [],
      sourceOfLead: '',
      tags: [],
      warrantyOptions: ['IN_WARRANTY', 'OUT_OF_WARRANTY'],
      tasks: {},
      selectedLeadId: null,
      selectedBranchId: null,
      isModalOpen: false,
      selectedCompanyId: '',
      selectedContactId: null,
      showForm: false,
      checkBranch: false,
      leadTitle: '',
      company: '',
      ContactName: '',
      productName: null,
      nextContactIndex: 0,
      allContactsAdded: false,
      leadNameFilter: '',
      leadName: '',
      formSubmitted: false,
      searchCompany: null,
      productMaker: null,
      modelNumber: '',
      leadDescription: '',
      ContactFirstName: '',
      ContactDesignation: '',
      ContactNumber: '',
      ContactEmail: '',
      decisionMaker: '',
      searchProduct: null,
      productBillNumber: '',
      showContactDialog: false,
      showAddCompany: false,
      showAddBranch: false,
      warrantyPeriods: [
        { text: '6 Months', value: 0.5 },
        { text: '1 Years', value: 1 },
        { text: '2 Years', value: 2 },
        { text: '3 Years', value: 3 },
        { text: '5 Years', value: 5 }
      ],
      productPrice: null,
      haveExtendedWarranty: false,
      extendedWarrantyPeriod: null,
      defaultWarrantyPeriod: 1,
      haveAmcPlan: null,
      warrantyStatus: undefined,
      productSoldOn: null,
      productWarrantyEndDate: null,
      productMakeDate: null,
      productAmcEndDate: null,
      isEditing: false,
      localEditItems: {}, // Create a local copy of editItems
      editableContacts: [], // Store editable contact data
      activeTab: 'lead', // Track the active tab
      showSaveButton: true, // Control save button visibility
      rules: {
        amcEndDate: [
          (val) => {
            if (this.haveAmcPlan !== null) {
              return (val || '').length > 0 || `AMC end date is required`
            }
            return true
          }
        ]
      }
    }
  },
  props: {
    tabSwitch: Function,
    fetchCompanies: Function,
    companies: Array,
    editItems: Object,
    useCaseLeadConfig: Object,
    leadLable: Object
  },
  watch: {
    editItems: {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          this.localEditItems = { ...newVal }
          this.$nextTick(() => {
            this.populateEditData()
          })
        }
      },
      immediate: true,
      deep: true
    },
    selectedCompanyContacts: {
      handler(newVal) {
        // Update editable contacts when selected company contacts change
        this.updateEditableContacts(newVal)
      },
      immediate: true
    }
  },
  async mounted() {
    this.populateLeadName()
    if (this.localEditItems && Object.keys(this.localEditItems).length > 0) {
      // Use nextTick to ensure DOM is updated before populating data
      this.$nextTick(() => {
        this.populateEditData()
      })

      if (this.localEditItems?.company?.name) {
        this.$emit('search', this.localEditItems.company.name)
      }

      if (this.localEditItems?.productName?.productName) {
        this.searchProduct = this.localEditItems.productName.productName
        await this.fetchProducts()
      }
    }
  },
  computed: {
    mainTabs() {
      const entity = this.isComplaintsEnabled ? 'Product' : 'Lead'
      const tabs = [
        {
          label: this.isEditing ? `Edit ${entity}` : `Add ${entity}`,
          key: 'lead',
          icon: this.isEditing ? 'mdi-pencil' : 'mdi-plus',
          component: 'AddLender'
        },
        {
          label: this.isEditing ? 'Bulk update' : 'Bulk create',
          key: 'bulk',
          icon: 'mdi-upload',
          component: 'GenericBulkUpload'
        }
      ]
      return tabs
    },
    selectedCompanyName() {
      if (this.selectedCompanyId) {
        const selectedCompany = this.companies.find(
          (company) => company._id === this.selectedCompanyId
        )
        return selectedCompany ? selectedCompany.name : ''
      }
      return ''
    },
    selectedCompanyContacts() {
      if (this.selectedBranchId !== null) {
        const selectedBranch = this.selectedCompanyBranches.find(
          (branch) => branch._id === this.selectedBranchId
        )
        return selectedBranch ? selectedBranch.contacts : []
      }
      return []
    },
    selectedCompanyBranches() {
      const selectedCompany = this.companies.find(
        (company) => company._id === this.selectedCompanyId
      )

      return selectedCompany
        ? sortDropdownOptions(selectedCompany.companyBranches, 'address.addressLine1')
        : []
    },
    filteredProductMakers() {
      if (!this.productName) return []
      const selectedProduct = this.products.find((product) => product._id === this.productName)
      return selectedProduct ? sortDropdownOptions(selectedProduct.productMaker, 'partnerName') : []
    },
    remainingChar() {
      const character = this.leadDescription
        .trim()
        .split('')
        .filter((character) => character !== '')
      return 300 - character.length
    },

    isComplaintsEnabled() {
      if (this.$route.params.usecase === 'inventory') return true
      return false
    },
    isDefaultEnabled() {
      return this.$route.params.usecase === 'default'
    }
  },
  methods: {
    resetForm() {
      // Reset all form fields to their initial state
      this.selectedBranchId = null
      this.selectedCompanyId = ''
      this.selectedContactId = null
      this.productName = null
      this.productMaker = null
      this.modelNumber = ''
      this.leadDescription = ''
      this.productBillNumber = ''
      this.productPrice = null
      this.haveExtendedWarranty = false
      this.extendedWarrantyPeriod = null
      this.defaultWarrantyPeriod = 1
      this.haveAmcPlan = null
      this.warrantyStatus = undefined
      this.productSoldOn = null
      this.productWarrantyEndDate = null
      this.productMakeDate = null
      this.productAmcEndDate = null
      this.leadName = ''
      this.sourceOfLead = ''
      this.leadTags = []
      this.isEditing = false
      this.localEditItems = {}
      this.editableContacts = [] // Reset editable contacts
    },

    updateEditableContacts(contacts) {
      // Convert contact objects to editable format
      this.editableContacts = contacts.map((contact) => ({
        _id: contact._id,
        fullName: `${contact.firstName || ''} ${contact.lastName || ''}`.trim(),
        firstName: contact.firstName || '',
        lastName: contact.lastName || '',
        designation: contact.designation || '',
        phoneNumber: contact.phoneNumber || '',
        email: contact.email || '',
        decisionMaker: contact.isDecisionMaker ? 'Yes' : 'No',
        isDecisionMaker: contact.isDecisionMaker || false
      }))
    },

    populateEditData() {
      if (!this.localEditItems || Object.keys(this.localEditItems).length === 0) {
        return
      }

      const formatDate = (date) => (date ? this.$dayjs(date).format('YYYY-MM-DD') : null)

      // Set all the form fields based on the edit data
      this.selectedBranchId = this.localEditItems?.selectedBranch || null
      this.selectedCompanyId = this.localEditItems?.company?._id || ''
      this.selectedContactId = this.localEditItems?.selectedContact || null
      this.productName = this.localEditItems?.productName?._id || null
      this.productMaker = this.localEditItems?.productManufacturer?._id || null
      this.modelNumber = this.localEditItems?.productModelNumber || ''
      this.leadDescription = this.localEditItems?.leadDescription || ''
      this.productBillNumber = this.localEditItems?.productBillNumber || ''
      this.productPrice = this.localEditItems?.productPrice || null
      this.haveExtendedWarranty = this.localEditItems?.productHaveExtendedWarranty || false
      this.extendedWarrantyPeriod = this.localEditItems?.productExtendedWarrantyPeriod || null
      this.defaultWarrantyPeriod = this.localEditItems?.productDefaultWarrantyPeriod || 1
      this.haveAmcPlan = this.localEditItems?.productHaveAmcPlan || null
      this.warrantyStatus = this.localEditItems?.productWarrantyStatus || undefined
      this.productSoldOn = formatDate(this.localEditItems?.productSoldOn) || null
      this.productWarrantyEndDate = formatDate(this.localEditItems?.productWarrantyEndDate) || null
      this.productMakeDate = formatDate(this.localEditItems?.productMakeDate) || null
      this.productAmcEndDate = formatDate(this.localEditItems?.productAmcDate) || null
      this.leadName = this.localEditItems?.leadTitle || ''
      this.sourceOfLead = this.localEditItems?.sourceOfLead || ''
      this.leadTags = this.localEditItems?.tags || []

      // Set the isEditing flag
      this.isEditing = !!this.localEditItems?._id

      // Trigger company and product searches if needed
      if (this.localEditItems?.company?.name) {
        this.$emit('search', this.localEditItems.company.name)
      }

      if (this.localEditItems?.productName?.productName) {
        this.searchProduct = this.localEditItems.productName.productName
        this.fetchProducts()
      }
    },
    async addLead() {
      this.formSubmitted = true
      if (!this.leadName.trim()) {
        return
      }
      try {
        const currentUsecase = this.$route.params.usecase.toLowerCase()
        const leadNames = this.leadName.split(',').map((name) => name.trim())

        const leadCreationPromises = leadNames.map(async (leadTitle) => {
          const data = {
            leadTitle: leadTitle,
            leadDescription: this.leadDescription,
            useCase: currentUsecase
          }
          if (this.selectedCompanyId) {
            data.company = this.selectedCompanyId
          }
          if (this.selectedBranchId) {
            data.selectedBranch = this.selectedBranchId
          }
          if (this.selectedContactId) {
            data.selectedContact = this.selectedContactId
          }
          if (this.isComplaintsEnabled) {
            data.productManufacturer = this.productMaker || undefined
            data.productModelNumber = this.modelNumber || ''
            data.productMakeDate = this.productMakeDate || null
            data.productSoldOn = this.productSoldOn || null
            data.productPrice = this.productPrice || null
            data.productWarrantyEndDate = this.productWarrantyEndDate || null
            data.productHaveExtendedWarranty = this.haveExtendedWarranty
            data.productExtendedWarrantyPeriod = this.extendedWarrantyPeriod || null
            data.productDefaultWarrantyPeriod = this.defaultWarrantyPeriod || null
            data.productHaveAmcPlan = this.haveAmcPlan
            data.productAmcEndDate = this.productAmcEndDate
            data.productWarrantyStatus = this.warrantyStatus
            data.productBillNumber = this.productBillNumber
            data.productName = this.productName || undefined
          }
          if (this.sourceOfLead || this.leadTags) {
            data.sourceOfLead = this.sourceOfLead
            data.tags = this.leadTags
          }
          let response
          if (this.isEditing) {
            response = await this.$axios.put(`/lead/${this.localEditItems?._id}`, data)
          } else {
            response = await this.$axios.post(`/lead`, data)
          }
          return response
        })
        await Promise.all(leadCreationPromises)
        this.leadName = ''
        this.leadDescription = ''
        this.productMaker = ''
        this.modelNumber = ''
        this.selectedCompanyId = ''
        this.selectedBranchId = null
        this.selectedContactId = null
        this.$toast.success(leadCreationSuccess(this.leadLable.leadTitle))
        this.showForm = false

        // Reset the form
        this.resetForm()

        // Emit event to notify parent component to refresh leads data
        this.$emit('lead-created')

        // Close the dialog
        this.$emit('close')

        // Navigate back to leads tab, but only if not already there
        const currentRoute = this.$route.query.activeTab
        if (currentRoute !== 'leads') {
          this.$router
            .replace({
              query: { ...this.$route.query, activeTab: 'leads' }
            })
            .catch((err) => {
              if (err.name !== 'NavigationDuplicated') {
                throw err
              }
            })
        }
      } catch (error) {
        this.$toast.error(leadCreationError(this.leadLable.leadTitle))
        console.error('Error creating new lead:', error)
      }
    },
    decisionMakerDisplay() {
      if (this.contact.isDecisionMaker === true) {
        return 'Yes'
      } else if (this.contact.isDecisionMaker === false) {
        return 'No'
      } else {
        return ''
      }
    },
    handleSaveButtonVisibility(visible) {
      // This is called by GenericBulkUpload when its internal tabs change
      const activeTab = this.$refs.tabComponent?.activeTab || 'lead'
      if (activeTab === 'bulk') {
        this.showSaveButton = visible
      } else {
        this.showSaveButton = true
      }
    },
    onTabChanged(tabKey) {
      if (tabKey === 'lead') {
        this.showSaveButton = true
      }
    },
    async addCompany(data) {
      const company = {
        name: data.companyName,
        companyDetails: data.companyDetails,
        companyBranches: [
          {
            alias: data.companyName,
            address: {
              addressLine1: data.addLine1,
              addressLine2: data.addLine2,
              city: data.city,
              state: data.state,
              country: data.country,
              pinCode: data.pinCode,
              coordinates: {
                latitude: data.latitude,
                longitude: data.longitude
              }
            }
          }
        ]
      }

      try {
        const response = await this.$axios.post('/company', company)

        this.companies.push(response.data.company)
        this.showAddCompany = false
        this.$toast.success(companyCreationSuccess)
      } catch (error) {
        console.error(companyCreationError, error)
        this.$toast.error(companyCreationError)
      }
    },
    validateLeadDescription() {
      const characterCount = this.leadDescription.trim().length
      if (characterCount > 300) {
        this.$toast.error(descriptionLimit)
        this.leadDescription = this.leadDescription.substring(0, 300)
      }
    },
    openAddContactDialog() {
      this.showContactDialog = true
    },
    removeChip(item, options) {
      const index = options.indexOf(item)
      if (index !== -1) {
        options.splice(index, 1)
      }
      if (this.leadTags.length > 0) {
        this.tags = this.leadTags
      }
    },
    handleContactAdded(updatedCompany) {
      const existingCompanyIndex = this.companies.findIndex(
        (company) => company._id === updatedCompany._id
      )
      if (existingCompanyIndex !== -1) {
        this.$set(this.companies, existingCompanyIndex, updatedCompany)
      }
      this.showContactDialog = false
      // Refresh company data to ensure the contact list is updated
      if (this.fetchCompanies) {
        this.fetchCompanies()
      }
    },
    async addBranch(data) {
      this.checkBranch = true
      const companyId = this.selectedCompanyId
      const company = {
        branch: {
          alias: data.alias,
          address: {
            addressLine1: data.addLine1,
            addressLine2: data.addLine2,
            city: data.city,
            state: data.state,
            country: data.country,
            pinCode: data.pinCode,
            coordinates: {
              latitude: data.latitude,
              longitude: data.longitude
            }
          }
        }
      }

      try {
        const response = await this.$axios.post(`/addBranch/${companyId}`, company)
        const newBranch = response.data.company.companyBranches
        this.selectedCompanyBranches.push(newBranch[newBranch.length - 1])
        this.checkBranch = false
        this.showAddBranch = false
        const successMessage = response?.data?.message || 'Company Branch Added Successfully !!!'
        this.$toast.success(successMessage)
      } catch (error) {
        console.error('Error in company addition', error)
        const errorMessage = error.response.data.message || 'Error in company branch addition !!!'
        this.$toast.error(errorMessage)
      }
    },
    cancelForm() {
      // Reset the form
      this.resetForm()

      // Close the dialog
      this.$emit('close')

      // Navigate back to leads tab, but only if not already there
      const currentRoute = this.$route.query.activeTab
      if (currentRoute !== 'leads') {
        this.$router
          .replace({
            query: { ...this.$route.query, activeTab: 'leads' }
          })
          .catch((err) => {
            if (err.name !== 'NavigationDuplicated') {
              throw err
            }
          })
      }
    },
    updateSelectedContact(contactId) {
      this.selectedContactId = contactId
    },
    calculateWarrantyEndDate() {
      if (this.productSoldOn) {
        const saleDate = this.$dayjs(this.productSoldOn)
        const years = Math.floor(this.defaultWarrantyPeriod)
        const months = Math.round((this.defaultWarrantyPeriod % 1) * 12)

        let warrantyEnd = saleDate.add(years, 'year').add(months, 'month')

        this.productWarrantyEndDate = warrantyEnd.format('YYYY-MM-DD')

        const currentDate = this.$dayjs()
        if (warrantyEnd.isAfter(currentDate)) {
          this.warrantyStatus = 'IN_WARRANTY'
        } else {
          this.warrantyStatus = 'OUT_OF_WARRANTY'
        }
      }
    },
    debounceProduct: debounce(function (text) {
      if (!text && this.localEditItems && Object.keys(this.localEditItems).length > 0) {
        this.products = []
        return
      }
      this.fetchProducts()
    }, 1000),
    async fetchProducts() {
      try {
        this.productLoading = true
        const params = {}
        if (this.searchProduct) {
          params.search = this.searchProduct
        }
        const response = await this.$axios.get(axiosUrl.products.getProducts, {
          params
        })
        const allProducts = response.data?.products

        this.products = sortDropdownOptions(allProducts, 'productName')
      } catch (error) {
        console.error('An error occurred:', error)
      } finally {
        this.productLoading = false
      }
    },
    populateLeadName() {
      let leadTitle = this.localEditItems?.leadTitle

      if (this.isComplaintsEnabled && !leadTitle) {
        this.leadName = this.generateLeadTitle()
      } else if (leadTitle) {
        this.leadName = leadTitle
      }
    },
    generateLeadTitle() {
      const prefix = 'SR_NO_'
      const dateTime = this.$dayjs().format('DD/MM/YY/hhmmss')
      return `${prefix}${dateTime}`
    },
    handleCompany: debounce(function () {
      if (this.selectedCompanyId) return
      this.$emit('search', this.searchCompany)
    }, 1000)
  }
}
</script>
<style scoped>
.form-content {
  padding: 10px;
  max-height: 70vh;
  overflow-y: auto;
  background-color: #f8f9fa;
}

.form-section {
  margin-bottom: 20px;
}

.form-content-border {
  width: 100%;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 16px;
  background-color: #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
}

.section-title {
  font-size: 1rem;
  font-weight: 500;
  color: #21427d;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
}

.section-content {
  padding-left: 8px;
}

/* Ensure consistent field spacing */
:deep(.v-text-field) {
  margin-bottom: 0;
}

:deep(.v-select) {
  margin-bottom: 0;
}

/* Dark theme support */
:deep(.theme--dark) .form-content {
  background-color: #2a2a2a;
}

:deep(.theme--dark) .form-content-border {
  background-color: #2d2d2d;
  border-color: #444;
}

:deep(.theme--dark) .section-title {
  color: #8cb6e1;
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .form-content {
    padding: 16px;
  }

  .form-section {
    margin-bottom: 16px;
  }
}

.v-textarea.v-text-field--enclosed.v-text-field--outlined.v-input--dense textarea {
  margin: 0px !important;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
